import { AlertBanner, AlertBannerTypes } from '@communicare/medications/Components/AlertBanner';

type TopbarBannerProps = {
    content: React.ReactNode;
};
const TopbarBanner: React.FC<TopbarBannerProps> = ({ content }) => {
    return <AlertBanner lowerHeight promptType={AlertBannerTypes.Warn} roundIcon infoLine={content} />;
};

export default TopbarBanner;
